module.exports = __webpack_public_path__ + "media/noise.8315f174.mp3";